import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import TextField from '@material-ui/core/TextField'
import RequieredInputs from '../../common/RequiredInputs'
import { BusinessUnitMultiSelect } from '../../fields'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { eventosActions } from '../../../actions/eventosActions'

const TaskForm = ({
  inputs,
  contacts,
  events,
  phases,
  businessunits,
  isDisable,
  handleSubmit,
  handleChange,
  textBtn,
}) => {
  const showEventText = () => {
    if (inputs.id_TipoAsunto !== '') {
      let eventSelected = events.filter(
        (e) => e.id_TipoAsunto === parseInt(inputs.id_TipoAsunto),
      )
      if (eventSelected[0].isAsuntoTexto) {
        return true
      } else {
        return false
      }
    }
  }

  events = _.orderBy(events, ['nombre'], ['asc'])
  phases = _.orderBy(phases, ['nombre'], ['asc'])
  contacts = _.orderBy(contacts, ['nombre'], ['asc'])

  const dispatch = useDispatch()
  const getAllEventos = () => dispatch(eventosActions?.getAllEventos())

  const [eventos, setEventos] = useState([])

  useEffect(() => {
    retrieveEventos()
  }, [])

  const retrieveEventos = async () => {
    const response = await getAllEventos()
    if (response?.payload) setEventos(response?.payload || [])
  }

  return (
    <div className='task__container'>
      <Form onSubmit={handleSubmit}>
        <div className='row form__container'>
          <div className='col-12 col-md-4'>
            <Form.Group controlId='role'>
              <Form.Label className='form__labels'>
                Evento <RequieredInputs />{' '}
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                type='text'
                name='id_TipoAsunto'
                onChange={handleChange}
                value={inputs?.id_TipoAsunto}
                placeholder='Elegir evento'
              >
                <option value={''}> Eligir evento </option>
                {events
                  ? events.map((event, i) => (
                      <option key={i} value={event.id_TipoAsunto}>
                        {event.nombre}
                      </option>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </div>

          <div className='col-12 col-md-4'>
            <Form.Group controlId='role'>
              <Form.Label className='form__labels'>
                Fase <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                type='text'
                name='id_TipoFase'
                onChange={handleChange}
                value={inputs.id_TipoFase}
                placeholder='Elegir evento'
              >
                <option value={''}> Eligir fase </option>
                {phases
                  ? phases.map((phase, i) => (
                      <option key={i} value={phase.id_TipoFase}>
                        {phase.nombre}
                      </option>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </div>

          <div className='col-12 col-md-4'>
            <Form.Group controlId='role'>
              <Form.Label className='form__labels'>
                Contacto <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                type='text'
                name='id_Contacto'
                onChange={handleChange}
                value={inputs?.id_Contacto}
                placeholder='Elegir evento'
              >
                <option value={''}> Eligir un contacto </option>
                {contacts
                  ? contacts.map((contact, i) => (
                      <option key={i} value={contact?.id_Contacto}>
                        {contact.nombre}
                      </option>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </div>
        </div>

        <div className='row form__container'>
          <div className='col-12'>
            <BusinessUnitMultiSelect
              value={inputs.businessUnits || []}
              onChange={(selectedIds) =>
                handleChange({
                  target: {
                    name: 'businessUnits',
                    value: selectedIds,
                  },
                })
              }
              label='Unidades de Negocio'
              placeholder='Selecciona las unidades de negocio para este lead...'
              required
            />
          </div>
        </div>

        <div className='row form__container'>
          <div className='col-12 col-md-8'>
            {/* {showEventText() ? ( */}
            <Form.Group size='lg' controlId='topic'>
              <Form.Label className='form__labels'>Asunto</Form.Label>
              <Form.Control
                className='user-input form__input'
                //
                type='text'
                name='asunto'
                value={inputs.asunto}
                onChange={handleChange}
                placeholder='Asunto'
              />
            </Form.Group>
            {/* ) : null} */}
          </div>
          <div className='col-12 col-md-4'>
            <Form.Group size='lg' controlId='actual-date'>
              <Form.Label className='form__labels'>
                Fecha <RequieredInputs />
              </Form.Label>
              <TextField
                name='fecha'
                id='datetime-local'
                type='datetime-local'
                onChange={handleChange}
                value={inputs.fecha}
              />
            </Form.Group>
          </div>
        </div>

        <div className='row form__container'>
          <div className='col-12 col-md-8'>
            <Form.Group size='lg' controlId='description'>
              <Form.Label className='form__labels'>Descripción</Form.Label>
              <Form.Control
                className='user-input form__input-description'
                type='text'
                name='descripcion'
                value={inputs.descripcion}
                onChange={handleChange}
                placeholder='Descripción'
              />
            </Form.Group>
          </div>
          <div className='col-12 col-md-4'>
            <Form.Group
              htmlFor='check-calendar'
              size='lg'
              style={{
                position: 'relative',
                top: '15px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Form.Check
                id='check-calendar'
                type='checkbox'
                name='isVerCaledario'
                checked={inputs.isVerCaledario}
                onChange={handleChange}
                label='Añadir al calendario'
              />
            </Form.Group>
          </div>
        </div>

        <div className='row form__container'>
          <div className='col-8'>
            <Form.Group controlId='role'>
              <Form.Label className='form__labels'>
                Evento relacionado
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                type='text'
                name='id_Evento'
                onChange={handleChange}
                value={inputs?.id_Evento}
                placeholder='Elegir evento'
              >
                <option value={''}> Seleccionar un Evento </option>
                {eventos
                  ? eventos.map((evento, i) => (
                      <option key={i} value={evento?.id_Evento}>
                        {evento.nombre}
                      </option>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </div>
        </div>

        <div className='row form__container'>
          {!handleSubmit ? null : (
            <button
              disabled={isDisable}
              onClick={handleSubmit}
              // disabled={isDisable}
              className='btn save'
            >
              {textBtn}
            </button>
          )}
        </div>
      </Form>
    </div>
  )
}

export default TaskForm
